import React from 'react';

interface ViewProps {
  width?: number;
  height?: number;
}

export const LeftImgView = ({ width = 66, height = 50 }: ViewProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 67 54"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1.16669"
      y="0.5"
      width="21"
      height="49"
      rx="1.5"
      stroke="#333745"
      strokeDasharray="3 3"
    />
    <rect x="4.16669" y="3.5" width="15" height="43" rx="2" fill="#F3F4F6" />
    <path
      d="M8.04083 26.0044C8.10721 25.8979 8.19952 25.8101 8.30906 25.7492C8.41861 25.6884 8.5418 25.6564 8.66704 25.6564C8.79229 25.6564 8.91548 25.6884 9.02503 25.7492C9.13457 25.8101 9.22688 25.8979 9.29326 26.0044L11.6667 29.812H5.66669L8.04009 26.0044H8.04083Z"
      fill="#DDE0E4"
    />
    <path
      d="M12.8062 22.7156C12.8675 22.5926 12.9618 22.4892 13.0784 22.4169C13.1951 22.3446 13.3295 22.3063 13.4667 22.3063C13.6039 22.3063 13.7383 22.3446 13.855 22.4169C13.9717 22.4892 14.0659 22.5926 14.1273 22.7156L17.6667 29.8126H9.26672L11.3669 25.6015L12.8069 22.7156H12.8062Z"
      fill="#DDE0E4"
    />
    <path
      d="M8.66712 23.7974C9.66143 23.7974 10.4675 22.9893 10.4675 21.9925C10.4675 20.9956 9.66143 20.1875 8.66712 20.1875C7.67281 20.1875 6.86676 20.9956 6.86676 21.9925C6.86676 22.9893 7.67281 23.7974 8.66712 23.7974Z"
      fill="#DDE0E4"
    />
    <rect
      x="27.1667"
      y="0.5"
      width="39"
      height="49"
      rx="1.5"
      stroke="#333745"
      strokeDasharray="3 3"
    />
  </svg>
);
